export const LOGOS = {
    "Triple Gana": require("@/assets/logos/triplegana.png"),
    "Caracas": require("@/assets/logos/caracas.png"),
    "Chance": require("@/assets/logos/chance.png"),
    "Zulia": require("@/assets/logos/zulia.jpg"),
    "Super Gana": require("@/assets/logos/supergana.png"),
    "Caliente": require("@/assets/logos/triplecaliente.png"),
    "Tachira": require("@/assets/logos/tachira.png"),
    "Centena Plus": require("@/assets/logos/centenap.png"),
    "TriÑapa": require("@/assets/logos/trinapa.png"),
    "Terminalito": require("@/assets/logos/terminalito.png"),
    "Colombiana": require("@/assets/logos/colombiana.png"),
    "Florida Cash": require("@/assets/logos/floridacash.png"),
    "Ricachona": require("@/assets/logos/ricachona.png"),
    "Ricacho": require("@/assets/logos/ricachona.png"),
    "Granjita": require("@/assets/logos/tergranjita.png"),
    "background": require("@/assets/background.jpg"),
}

export const ANIMALS_IMAGES = {
    "CondorGana": "animalesConGua",
    'Guacharo Activo': "animalesConGua",
    "FruitaGana": "frutas",
    "Granjazo": "animalesGran",
    "default": 'animales',
}

export const LOTTERY_NAMES = {
    LA_GRANJITA: "La Granjita",
    SELVAPLUS: "SelvaPlus",
    GUACHARO: "Guacharo Activo",
    GRANJAZO: "Granjazo",
    GRANJAMILLO_ANI: "Granja Millonaria",
    LOTTOREY: "LottoRey",
    CONDORGANA: "CondorGana",
    FRUITAGANA: "FruitaGana",
    TROPIGANA: "TropiGana",
    CHANCEANIMAL: "Chance Animal",
    COMBINAFT: "Combina FT",
    LOTTOACTIVO: "LottoActivo",
    SUPERGANA_SIG: "Super Gana",
    TACHIRA_SIG: "Tachira",
    TRIPLEGANA_SIG: "Triple Gana",
    CHANCE_SIG: "Chance",
    TRINAPA: "TriÑapa",
    CENTENAP: "Centena Plus",
    RICACHONA: "Ricachona",
    TERMINALITO: "Terminalito",
    TER_RICACHO: "Ricacho",
    TER_GRANJITA: "Granjita",
    TACHIRA: "Tachira",
    CHANCE: "Chance",
    COLOMBIANA: "Colombiana",
    USA: "Florida Cash",
}

